import { GeofenceRuleCreation, GeofenceRuleResource, UserDefinedGeofenceResource } from 'services/resources';
import request from '../../request';
import { isNil } from 'lodash';

/**
 * Gets the dealership list of geofences
 */
export function geofences() {
  return request('geofencing/geofences/', {
    method: 'GET',
  });
}

/**
 * Creates or updates a geofence
 */
export function createUpdateGeofence(name: string, geofence: any, id: number) {
  const url = `geofencing/geofences/${!isNil(id) ? `${id}/` : ''}`;
  const method = !isNil(id) ? 'PATCH' : 'POST';

  const modifiedGeofence = { ...geofence };

  if (geofence.polygon) {
    // First and last coordinate need to be the same in the database to complete the polygon
    if (modifiedGeofence.polygon.length > 0) {
      modifiedGeofence.polygon.push(modifiedGeofence.polygon[0]);
    }
  }

  return request<UserDefinedGeofenceResource>(url, {
    method,
    data: {
      ...modifiedGeofence,
      name,
    },
  });
}

/**
 * Deletes a geofence
 */
export function deleteGeofence(id) {
  return request(`geofencing/geofences/${id}/`, {
    method: 'DELETE',
  });
}

/**
 * Gets the list of geofence rules
 */
export function getGeofenceRules() {
  return request<GeofenceRuleResource[]>('geofencing/rules/', {
    method: 'GET',
  });
}

export function patchGeofenceRule(id, rule) {
  return request<GeofenceRuleResource>(`geofencing/rules/${id}/`, {
    method: 'PATCH',
    data: {
      ...rule,
    },
  });
}

export function postGeofenceRule(rule: GeofenceRuleCreation) {
  return request<GeofenceRuleResource>('geofencing/rules/', {
    method: 'POST',
    data: {
      ...rule,
    },
  });
}

export function deleteGeofenceRuleRequest(id: number) {
  return request(`geofencing/rules/${id}/`, {
    method: 'DELETE',
  });
}
